import { jsx as o, jsxs as j, Fragment as v } from "react/jsx-runtime";
import { Listbox as y, ListboxButton as B, ListboxOptions as C, ListboxOption as N } from "@headlessui/react";
import { useState as R } from "react";
import { twMerge as r } from "tailwind-merge";
import { ListLoader as S } from "./components/list-loader.mjs";
import { ListOptionsWrapper as w } from "./components/list-options-wrapper.mjs";
import { getPanelHeight as D } from "./utils/get-panel-height.mjs";
import { renderOption as F } from "./utils/render-list-option.mjs";
function E({
  value: t,
  onChange: n,
  children: s,
  optionsClassName: m,
  data: e,
  loaderClassName: p,
  loaderWrapperClassName: l,
  optionClassName: f,
  optionIconWrapperClassName: c,
  disabled: h,
  buttonClassName: u,
  optionsProps: L
}) {
  const g = e == null ? void 0 : e.find((i) => i.id === t), [x, b] = R(null), d = D(x, e);
  return /* @__PURE__ */ o(y, { disabled: h, value: g, onChange: (i) => n(i == null ? void 0 : i.id), children: ({ open: i }) => /* @__PURE__ */ j(v, { children: [
    /* @__PURE__ */ o(
      B,
      {
        className: r(
          "ring-brand-primary outline-hidden focus-visible:ring-2",
          u
        ),
        children: s(i)
      }
    ),
    /* @__PURE__ */ o(
      w,
      {
        ref: b,
        style: { height: d },
        as: C,
        optionsClassName: r("h-fit outline-hidden", m),
        optionsProps: L,
        children: e ? e.map(
          (O) => F({
            item: O,
            as: N,
            optionClassName: f,
            optionIconWrapperClassName: c
          })
        ) : /* @__PURE__ */ o(
          S,
          {
            loaderWrapperClassName: l,
            loaderClassName: p
          }
        )
      }
    )
  ] }) });
}
export {
  E as ListBoxSelect
};
